import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import OrderpomappingFilterCriteria from './OrderpomappingFilterCriteria'
import OrderpomappingList from './OrderpomappingList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './OrderpomappingAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setOrderpomappingDashboardOrderpomappingList } from '../../store/slice/PharmaSlice';

export default function OrderpomappingListView({setShowEdit,setOrderpomappingId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.orderpomappingDashboard);   

    const [filteredOrderpomappingList, setFilteredOrderpomappingList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { orderpomappingDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (orderpomappingDashboard.orderpomappingList.length>-1){
        setFilteredOrderpomappingList(orderpomappingDashboard.orderpomappingList);
        transformToCardFormat(orderpomappingDashboard.orderpomappingList, setCardList);
      }
    },[orderpomappingDashboard.orderpomappingList])

    useEffect(()=>{
          transformToCardFormat(filteredOrderpomappingList, setCardList);
      },[filteredOrderpomappingList])

    useEffect(()=>{
        if (filterCriteria.orderid==='' && filterCriteria.poid==='' ){
            setFilteredOrderpomappingList(orderpomappingDashboard.orderpomappingList);
            transformToCardFormat(orderpomappingDashboard.orderpomappingList, setCardList);

        } else {
            setFilteredOrderpomappingList(
                orderpomappingDashboard.orderpomappingList
                    .filter(orderpomapping=> orderpomapping.orderid.toString().toUpperCase().includes(filterCriteria.orderid.toString().toUpperCase()))
.filter(orderpomapping=> orderpomapping.poid.toString().toUpperCase().includes(filterCriteria.poid.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(orderpomappingDashboard.filteredOrderpomappingList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <OrderpomappingList
                    setShowEdit={setShowEdit}
                    setOrderpomappingId = {setOrderpomappingId}
                    tableList={filteredOrderpomappingList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}